export function getMostVisibleElement(elements: Element[]) {
  if (!elements || elements.length === 0) {
    return null;
  }

  let mostVisibleElement: Element | null = null;
  let maxVisibleArea = -1;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  for (const element of elements) {
    const rect = element.getBoundingClientRect();

    const intersectionTop = Math.max(0, rect.top);
    const intersectionLeft = Math.max(0, rect.left);
    const intersectionBottom = Math.min(viewportHeight, rect.bottom);
    const intersectionRight = Math.min(viewportWidth, rect.right);

    const visibleHeight = Math.max(0, intersectionBottom - intersectionTop);
    const visibleWidth = Math.max(0, intersectionRight - intersectionLeft);
    const visibleArea = visibleHeight * visibleWidth;

    if (visibleArea > maxVisibleArea) {
      maxVisibleArea = visibleArea;
      mostVisibleElement = element;
    }
  }

  return mostVisibleElement;
}
